import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'list' })
export class ListPipe implements PipeTransform {
  transform(items: (string | number)[]): string {
    return items.filter(item => item).join(', ');
  }
}
